
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/acceder",
      function () {
        return require("private-next-pages/acceder/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/acceder"])
      });
    }
  